import { Card, Stack, Tabs, useMatches } from "@mantine/core";

import {
  UserProfileSidebar,
  UserProfileTabAddress,
  UserProfileTabAdmin,
  UserProfileTabBilling,
  UserProfileTabContacts,
  UserProfileTabPersonalInfo,
  UserProfileTabSecurity,
  UserProfileTabSettings,
} from "./components";

import type { FC } from "react";

type UserProfileProps = {
  activeTab?: string;
};

type UserProfileComponent = FC<UserProfileProps> & {
  Sidebar: typeof UserProfileSidebar;
};

const Component: UserProfileComponent = ({ activeTab }) => {
  const isMobile = useMatches({ base: true, md: false });

  return (
    <Stack h="100%" mih="25em" gap="sm" p={isMobile ? "0px" : "lg"}>
      <Tabs defaultValue={activeTab} value={activeTab}>
        <Tabs.Panel value="admin" pt="xs">
          <Card radius="md" h="100%" p="lg">
            <UserProfileTabAdmin />
          </Card>
        </Tabs.Panel>
        <Tabs.Panel value="personal-info" pt="xs">
          <Card radius="md" h="100%" p="lg">
            <UserProfileTabPersonalInfo />
          </Card>
        </Tabs.Panel>
        <Tabs.Panel value="contacts" pt="xs">
          <Card radius="md" h="100%" p="lg">
            <UserProfileTabContacts />
          </Card>
        </Tabs.Panel>
        <Tabs.Panel value="address" pt="xs">
          <UserProfileTabAddress />
        </Tabs.Panel>
        <Tabs.Panel value="billing" pt="xs">
          <UserProfileTabBilling />
        </Tabs.Panel>
        <Tabs.Panel value="settings" pt="xs">
          <Card radius="md" h="100%" p="lg">
            <UserProfileTabSettings />
          </Card>
        </Tabs.Panel>
        <Tabs.Panel value="security" pt="xs">
          <Card radius="md" h="100%" p="lg">
            <UserProfileTabSecurity />
          </Card>
        </Tabs.Panel>
      </Tabs>
    </Stack>
  );
};

Component.Sidebar = UserProfileSidebar;

export const UserProfile = Component;
